import type { ProgramContent } from '../../interface/Program';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/libs/axios/api';
import { apiConfig } from '@/config/api';

const getProgramContents = async ({
  id,
  page,
  season,
}: UseGetProgramContents) => {
  try {
    const { data } = await api.get<{ data: ProgramContent[] }>(
      apiConfig.routes.entertainment.program.v1.contents(id),
      { params: { limit: 100, page, season } }
    );

    return data.data;
  } catch {
    const { data } = await api.get<{ data: ProgramContent[] }>(
      apiConfig.routes.entertainment.program.v1.publicContents(id),
      { params: { limit: 100, page, season } }
    );

    return data.data;
  }
};

export const useGetProgramContents = ({
  id,
  page = 1,
  season,
}: UseGetProgramContents) =>
  useQuery({
    queryKey: ['program', id, season, 'contents', { page }],
    queryFn: () => getProgramContents({ id, page, season }),
  });

type UseGetProgramContents = {
  id: string;
  season: string;
  page?: number;
};
